module.exports = __webpack_public_path__ + "img/2.cfbd0f0b.jpg";